import { combineReducers } from "redux";
import customAttribute from "./customAttribute";
import apiCall from "./ApiCall";
import Workspace from "./Workspace";
import Home from "./Home";
import attributes from "./Attribute";
import Worksheets from "./Worksheets";
import DisplayChart from "./DisplayChart";
import DeepDive from "./DeepDive";
import CreateWorkspace from "./CreateWorkspace";
import Template from "./Template";
import Authentication from "./Auth";
import Filter from "./Filter";
import LandingPage from "./LandingPage";
import SmartInsights from "./SmartInsights";
import Sidebar from "./Sidebar";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import DateTime from "./DateTime";
import Split from "./Split";
import sankyQueries from "./SankyQueries";
import Tab1 from "./dashboard/Tab1";
import addSection from "./templates/AddSection";
import Section from "./section/section";
import Widget from "./widget/widget";
import ApiCall from "./ApiCall/apiCall";
import dashboard from "./dashboard/dashboard";
import Welcome from "./dashboard/Welcome";
import ChannelsData from "./channelsData/channelsData";
import OrmWidget from "./ormWidget/ormWidget";
import Orm from "./ormWidget/Orm";
import PdfDownloadData from "./pdfdownload/pdfdownload";
import OrmDataPersist from "./ormWidget/OrmDataPersists";
import Share from "./share/Share";
import AuthParams from "./AuthParams";
import TicketTATSimpleView from "./TicketTATSimpleView/TicketTATSimpleView";
import Logicalgroup from "./LogicalGroup";
import Highchart from "../reducers/HighChart";
import WidgetMaker from "./WidgetMaker/WidgetMaker";
import GraphConfig from "./WidgetMaker/GraphConfig";
import WidgetAPI from "./WidgetMaker/WidgetAPI";
import WidgetLibrary from "./WidgetMaker/WidgetLibrary";
import PPT from "./PPT";
import scheduleReport from "./scheduleReport/scheduleReport";
import ProfileFilter from "./ProfileFilter";
import CommandCenter from "./commandCenter/commandCenter";
import Screens from "./commandCenter/screens/screens";
import Network from "./Network";
import PlannedValue from "./PlannedValue";
import PersonalizationSetting from "./DIYPersonalization/PersonalizationSettings";
import DeepDiveDashboard from "./DeepDiveDashboard/DeepDiveDashboard";
const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "attributes",
    "Tab1",
    "Welcome",
    "Section",
    "ChannelsData",
    "OrmDataPersist",
    "AuthParams",
  ],
};
const rootReducer = combineReducers({
  customAttribute,
  apiCall,
  Workspace,
  Home: Home,
  attributes: attributes,
  Worksheets,
  DisplayChart,
  DeepDive,
  CreateWorkspace,
  Template,
  Authentication,
  Filter,
  LandingPage,
  SmartInsights,
  Sidebar,
  DateTime,
  Split,
  sankyQueries: sankyQueries,
  Tab1: Tab1,
  Welcome: Welcome,
  Section: Section,
  Widget,
  ApiCall,
  addSection,
  dashboard,
  ChannelsData: ChannelsData,
  OrmWidget,
  Orm,
  PdfDownloadData,
  OrmDataPersist: OrmDataPersist,
  Share,
  AuthParams: AuthParams,
  TicketTATSimpleView,
  Logicalgroup,
  Highchart,
  WidgetAPI,
  WidgetLibrary,
  WidgetMaker,
  GraphConfig,
  PPT,
  scheduleReport,
  ProfileFilter,
  CommandCenter,
  Screens,
  Network,
  PlannedValue,
  PersonalizationSetting,
  DeepDiveDashboard,
});

export default persistReducer(persistConfig, rootReducer);
